export const COLORS = ['#82ca9d', '#8884d8', '#ff7300', '#0088FE', '#FF8042'];
